import React from "react"
import { Card, Grid, Typography } from "@mui/material"
import CheckBoxTwoToneIcon from "@mui/icons-material/CheckBoxTwoTone"

const HistoryItem = ({ details, setCurrentBook, isMobile }) => {
  const { book, priceNegotiated } = details
  const { title } = book

  return (
    <Card
      variant="outlined"
      onClick={() => setCurrentBook(details)}
      sx={{
        width: "90%",
        mx: "5%",
        my: "1vh",
        height: "auto",
        px: "1vw",
        py: 1,
        cursor: "pointer",
        "&:hover": { backgroundColor: "hover.main" },
      }}>
      <Grid container alignItems="center">
        <Grid item xs="auto">
          <CheckBoxTwoToneIcon sx={{ verticalAlign: "bottom", mr: 1 }} />
        </Grid>
        {priceNegotiated ? (
          <Grid item xs={isMobile ? 3 : 2}>
            <Typography>{priceNegotiated} €</Typography>
          </Grid>
        ) : (
          <></>
        )}
        <Grid item xs>
          <Typography>{title}</Typography>
        </Grid>
      </Grid>
    </Card>
  )
}

export default HistoryItem
